import * as SaleServiceModels from '../../models/sale-service/sale-service';
import { SaleServiceSearchModel } from '../../models/sale-service/sale-serviceSearch';


export class GetList {
  static readonly type = '[SaleService] List';
  constructor(public Search: SaleServiceSearchModel) { }
}

export class SetSearch {
  static readonly type = '[SaleService] Set Search';
  constructor(public Search: SaleServiceSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[SaleService] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[SaleService] Set List Page';
  constructor(public Search: SaleServiceSearchModel) { }
}

export class GetListSummary {
  static readonly type = '[SaleService] GetListSummary';
  constructor(public Search: SaleServiceSearchModel) { }
}


export class GetFilteredReport {
  static readonly type = '[SaleService] GetFilteredReport';
  constructor(public Search: SaleServiceSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[SaleService] DisposeSearch';
  constructor() { }
}
